export enum NotificationLevel
{
  Unknown = 0,
  Info = 1,
  Success = 2,
  Warning = 3,
  Danger = 4
}
